module.exports = __webpack_public_path__ + "media/images/svg-icon/pages-9a66210016beec5cd8975a4f4d5e53ba.svg";